export default __webpack_public_path__ + "static/media/event_sd_benefit_bg.4a5e3073.jpg";